import React from 'react';
import { Button } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';

/**
 * @param {string}   filename  — the downloaded file name, e.g. "view-details.csv"
 * @param {Array<Object>} data     — your array of row-objects
 * @param {Array<{ label: string, key: string }>} columns — the CSV columns you want
 */
export default function ExportCsvButton({ filename, data, columns }) {
    const handleClick = () => {
        if (!data || !Array.isArray(data) || !data.length) return;
        if (!columns || !Array.isArray(columns)) return;

        const header = columns.map(c => `"${c.label}"`).join(',');
        const rows = data.map(row => {
            if (!row) return ""; 
            return columns
                .map(c => {
                    let cell = row[c.key] ?? '';
                    if (cell instanceof Date) cell = cell.toLocaleString();
                    return `"${String(cell).replace(/"/g, '""')}"`;
                })
                .join(',')
        }).filter(r => r); 
        const csv = [header, ...rows].join('\r\n');
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        URL.revokeObjectURL(link.href);
    };

    return (
        <Button
            variant="contained"
            color="primary"
            onClick={handleClick}
            startIcon={<GetAppIcon sx={{ color: 'common.white' }} />}
            sx={{
                height: 40,
                textTransform: 'none',
                color: 'common.white',
                px: 5,
                py: 0,
                borderRadius: 1,
                '&:hover': {
                    backgroundColor: 'primary.dark'
                }
            }}
        >
            Export
        </Button>
    );
}
